import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1687fe16"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "info-message" };
const _hoisted_2 = _createStaticVNode(" This website is using the <a href=\"https://infiniteflight.com/guide/developer-reference/live-api/overview\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"info-message\" data-v-1687fe16>Infinite Flight Live API</a>. <br data-v-1687fe16><br data-v-1687fe16> Special thanks to <a href=\"https://community.infiniteflight.com/u/cameron/summary\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"info-message\" data-v-1687fe16>Cameron Carmichael Alonso</a> &amp; <a href=\"https://community.infiniteflight.com/u/kaim/summary\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"info-message\" data-v-1687fe16>Kai Malcolm</a>. <br data-v-1687fe16><br data-v-1687fe16> Developer : <a href=\"https://community.infiniteflight.com/u/a-fitzgerald/summary\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"info-message\" data-v-1687fe16>Avon FitzGerald</a> <br data-v-1687fe16> Email : <a href=\"mailto: avon@infinitex.app\" class=\"info-message\" data-v-1687fe16>avon@infinitex.app</a> <br data-v-1687fe16><hr class=\"margin-block-small\" data-v-1687fe16>", 21);
const _hoisted_23 = _createTextVNode("Terms of Service");
const _hoisted_24 = _createTextVNode();
const _hoisted_25 = _withScopeId(() => _createElementVNode("br", null, null, -1));
const _hoisted_26 = _createTextVNode("Privacy Policy");
const _hoisted_27 = _createTextVNode();
const _hoisted_28 = _withScopeId(() => _createElementVNode("br", null, null, -1));
const _hoisted_29 = _createTextVNode("Refund Policy");
const _hoisted_30 = _createTextVNode();
const _hoisted_31 = _withScopeId(() => _createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_router_link, {
            to: "terms-of-service",
            class: "white",
            onClick: _ctx.onClose
        }, {
            default: _withCtx(() => [
                _hoisted_23
            ]),
            _: 1
        }, 8, ["onClick"]),
        _hoisted_24,
        _hoisted_25,
        _createVNode(_component_router_link, {
            to: "privacy-policy",
            class: "white",
            onClick: _ctx.onClose
        }, {
            default: _withCtx(() => [
                _hoisted_26
            ]),
            _: 1
        }, 8, ["onClick"]),
        _hoisted_27,
        _hoisted_28,
        _createVNode(_component_router_link, {
            to: "refund-policy",
            class: "white",
            onClick: _ctx.onClose
        }, {
            default: _withCtx(() => [
                _hoisted_29
            ]),
            _: 1
        }, 8, ["onClick"]),
        _hoisted_30,
        _hoisted_31
    ]));
}
